import { render, staticRenderFns } from "./room-card.vue?vue&type=template&id=3f5d1c48&scoped=true&"
import script from "./room-card.vue?vue&type=script&lang=ts&"
export * from "./room-card.vue?vue&type=script&lang=ts&"
import style0 from "./room-card.vue?vue&type=style&index=0&id=3f5d1c48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d1c48",
  null
  
)

export default component.exports